function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9891 1.16003V16.9011C24.9891 17.4975 24.7593 18.0694 24.3503 18.4911C23.9413 18.9128 23.3866 19.1498 22.8083 19.1498H3.18083C2.60243 19.1498 2.04776 18.9128 1.63878 18.4911C1.2298 18.0694 1 17.4975 1 16.9011V1.16003",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9899 1.16003L14.282 10.3123C13.9096 10.5912 13.4611 10.7413 13.0008 10.7413C12.5405 10.7413 12.0921 10.5912 11.7196 10.3123L1.01172 1.16003H25.0008H24.9899Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1.16003H24.9891",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPrayerRequests = function SvgPrayerRequests(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrayerRequests, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prayer_requests.18aa4c74.svg";
export { ForwardRef as ReactComponent };